export default "__VITE_ASSET__B6hOzbvP__"